/* This file is generated by createIcons.js any changes will be lost. */
import createIcon from '../createIcon';
var NeuterIcon = createIcon({
  name: 'NeuterIcon',
  height: 512,
  width: 288,
  svgPath: 'M288 176c0-79.5-64.5-144-144-144S0 96.5 0 176c0 68.5 47.9 125.9 112 140.4V468c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12V316.4c64.1-14.5 112-71.9 112-140.4zm-144 80c-44.1 0-80-35.9-80-80s35.9-80 80-80 80 35.9 80 80-35.9 80-80 80z',
  yOffset: '',
  xOffset: '',
  transform: ''
});
export default NeuterIcon;